export default "__VITE_ASSET__DAXit6cs__"